// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".SessionTimeoutModal_footer__2aNM{flex-direction:row-reverse}.SessionTimeoutModal_timeLeft__2cwh{display:block;text-align:center;font-size:24px}", "",{"version":3,"sources":["app/components/SessionTimeoutNotifier/SessionTimeoutModal.css"],"names":[],"mappings":"AAAA,kCACI,0BAAA,CAGJ,oCACI,aAAA,CACA,iBAAA,CACA,cAAA","file":"SessionTimeoutModal.css","sourcesContent":[".footer {\n    flex-direction: row-reverse;\n}\n\n.timeLeft {\n    display: block;\n    text-align: center;\n    font-size: 24px;\n}\n"]}]);
// Exports
exports.locals = {
	"footer": "SessionTimeoutModal_footer__2aNM",
	"timeLeft": "SessionTimeoutModal_timeLeft__2cwh"
};
module.exports = exports;
